import React, { useState, useEffect } from "react";
import _ from "lodash";
import Booking from "../components/Steps/Booking";
import { Spin, Button } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import History from "../components/Steps/History";
import { LeftOutlined } from "@ant-design/icons";
import Map from "../components/Steps/Map";

const Home = () => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("booking");
  const [dataServices, setDataServices] = useState(null);
  const [isPlaceHistory, setIsPlaceHistory] = useState(false);
  const [dataPlace, setDataPlace] = useState({
    from: {
      placeId: "",
      description: "",
      placeName: "",
      lat: "",
      lng: "",
      regionName: "",
    },
    to: {
      placeId: "",
      description: "",
      placeName: "",
      lat: "",
      lng: "",
      regionName: "",
    },
  });
  const [dataInputPlace, setDataInputPlace] = useState({
    from: "",
    to: "",
  });

  useEffect(() => {
    if (location.pathname === "/history") {
      setStep("history");
    } else if (location.pathname === "/taxi" && step === "history") {
      setStep("booking");
    }
  }, [location.pathname, step]);

  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      <div
        className="bg-white min-h-screen"
      >
        <div
          className="w-full h-[300px] absolute"
          style={{
            backgroundImage: `url(/images/bg-form.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        ></div>
        {/* <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm mx-4 text-center">
            <div className="text-4xl mb-4">🔧</div>
            <div className="text-base font-semibold text-gray-800 mb-2">
              Hệ thống đang bảo trì
            </div>
            <div className="text-sm text-gray-500">
              Vui lòng quay lại đặt chuyến sau
            </div>
          </div>
        </div> */}
        {step !== "map" && (
          <div className="flex w-full z-10 justify-between items-center">
            {step === "booking" ? (
              <div className="w-[67px] h-8"></div>
            ) : (
              <div className="w-[67px] ml-4">
                <Button
                  className="text-[14px]"
                  icon={<LeftOutlined color="#1677ff" />}
                  onClick={() => {
                    history.push("/taxi");
                  }}
                />
              </div>
            )}
            <div className="text-center">
              <a href="/taxi">
                <img
                  src={"/images/logo-taxi.jpg"}
                  alt=""
                  className="w-[60px] rounded-full"
                />
              </a>
            </div>
            {step === "booking" ? (
              <div className="p-5 cursor-pointer inline-block z-10">
                <img
                  onClick={() => {
                    history.push("/history");
                  }}
                  className="w-[32px] p-1 h-[32px] bg-white rounded-full"
                  src={"/images/history.svg"}
                  alt=""
                />
              </div>
            ) : (
              <div className="w-[67px] h-8"></div>
            )}
          </div>
        )}
        {step === "booking" && (
          <Booking
            setLoading={setLoading}
            loading={loading}
            setDataServices={setDataServices}
            setStep={setStep}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
            isPlaceHistory={isPlaceHistory}
            setIsPlaceHistory={setIsPlaceHistory}
          />
        )}
        {step === "map" && (
          <Map
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            dataServices={dataServices}
            setDataServices={setDataServices}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
          />
        )}
        {step === "history" && (
          <History
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            dataServices={dataServices}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
            setIsPlaceHistory={setIsPlaceHistory}
          />
        )}
      </div>
    </Spin>
  );
};

export default Home;
